import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputComponent, DropdownComponent, DropdownSearchComponent } from '@libs/ui-lib';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { ReactiveFormsModule } from '@angular/forms';
import { SiteSetupComponentService } from '../../../site-setup/site-setup.component.service';
import { statesDropdownOptions } from '../../states-dropdown-options.interface';

@Component({
  selector: 'lib-license-agreement-practice-form',
  imports: [
    CommonModule,
    SvgIconComponent,
    InputComponent,
    DropdownComponent,
    TranslateModule,
    CdkAccordionModule,
    ReactiveFormsModule,
    DropdownSearchComponent,
  ],
  templateUrl: './license-agreement-practice-form.component.html',
  styleUrl: './license-agreement-practice-form.component.scss',
})
export class LicenseAgreementPracticeFormComponent {
  private readonly siteSetupComponentService = inject(SiteSetupComponentService);
  public vm = this.siteSetupComponentService.viewModel;

  public licenseAgreementForm = this.siteSetupComponentService.getLicenseAgreementForm();
  public practiceControls = this.licenseAgreementForm.controls.practice.controls;
  public statesDropdownOptions = statesDropdownOptions;
}
